import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M13.15.5c4.042 0 7.432 1.219 9.82 3.31 2.392 2.094 3.748 5.041 3.748 8.422 0 5.502-3.64 10.703-8.076 15.357l-.003.004-4.684 4.821h13.303v8.938H.5v-7.777l.142-.146 9.99-10.26c1.588-1.642 3.031-3.26 4.077-4.865 1.047-1.607 1.667-3.158 1.667-4.668 0-1.25-.372-2.224-1.078-2.89-.71-.67-1.827-1.092-3.444-1.092-3.04 0-5.887 1.508-9.243 5.183l-.824.902-.045-1.22-.324-8.748-.006-.181.11-.143C3.8 2.486 8.447.5 13.15.5Z"
        />
    </Svg>
);
export { SvgComponent as TwoIcon };
